module.exports = __webpack_public_path__ + "static/icons/icon-thumbs-down-solid-d8da07eee6da4d1a8c14b84eac63e103.svg";